import React from "react";
import { Card } from "primereact/card";
import { Link, useLocation } from "react-router-dom";
import AdminOnly from "../../AdminOnly";

const SettingsSidebar = () => {
  const location = useLocation();
  const activeTab = location.pathname.split("/")[2] || "general-information";

  return (
    <>
      <Card className="card-style p-0">
        <div className="flex flex-column">
          <Link
            to="/settings/my-profile"
            className={`sidebar-align ${activeTab === "my-profile" ? "active-entity" : "menu-hover"}`}
          >
            <div className="flex align-items-center">
              <span className="pi pi-id-card icon-color"></span>
              <p className="sidebar-menu">My Account</p>
            </div>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
          {/* <Link
            to="/settings/notification"
            className={`sidebar-align ${activeTab === "notification" ? "active-entity" : "menu-hover"}`}
          >
            <div className="flex align-items-center">
              <span className="pi pi-bell icon-color"></span>
              <p className="sidebar-menu">Notification</p>
            </div>
            <span className="pi pi-angle-right icon-color"></span>
          </Link> */}
          <AdminOnly>
            <Link
              to="/settings/users"
              className={`sidebar-align ${activeTab === "users" ? "active-entity" : "menu-hover"}`}
            >
              <div className="flex align-items-center">
                <span className="pi pi-users icon-color"></span>
                <p className="sidebar-menu">Users</p>
              </div>
              <span className="pi pi-angle-right icon-color"></span>
            </Link>
          </AdminOnly>
        </div>
      </Card>
    </>
  );
};

export default SettingsSidebar;
